export type ZoneType = 'location' | 'nogo' | 'keepin' | 'route' | 'zone';

export type ZoneEditorAction = 'zoneaddpolyline' | 'zoneaddpolygon' | 'zoneedit' | 'zonedeletepolyline' | 'zonedeletepolygon' | 'zoneselect' | 'cancel';

export const ALL_ZONES: ZoneType[] = ['location', 'nogo', 'keepin', 'route', 'zone'];
export const ROUTES: ZoneType[] = ['route'];
export const GEOFENCE: ZoneType[] = ['location', 'nogo', 'keepin', 'zone'];